<template>
  <div class="order-wrapper">
    <portal target-el="#filter">
      <div class="sub-header">
        <!-- breadcrumb defining order type and OUTBOUND/INBOUND order -->
        <div class="header-item">
          <Breadcrumb type="flex" separator-class="el-icon-arrow-right">
            <breadcrumb-item v-if="isFromEximList" :to="{name: 'EximMasterIndent'}">
              {{masterIndentType}}
            </breadcrumb-item>
            <breadcrumb-item v-else :to="routeToIndents">
              {{$t(getCurrentIndentType.tlabel)}}
            </breadcrumb-item>
            <breadcrumb-item>
              <Select
                v-if="!disableChangeOrderType"
                :value="currentOrderDetails.type.name"
                :default-first-option="true"
                size="small"
                class="select-default select-indent"
                @change="setOrderType($event)"
              >
                <Option
                  v-for="item in allowedOrderTypes"
                  :key="item.id"
                  :label="$t(item.tlabel)"
                  :value="item.name"
                ></Option>
              </Select>
              <div v-else>
                {{$t(currentOrderDetails.type.tlabel)}}
              </div>
            </breadcrumb-item>
          </Breadcrumb>
        </div>
      </div>
    </portal>
    <div>
      <div>
        <ElTabs class="tab-default tab-md">
          <Tab-pane :label="$t('INDENT_DETAILS')">
            <div class="panel-card clearfix">
              <div class="card-left">
                <!-- List of Sources - Left pane-->
                <source-list
                  :data="sourcesDropOffs"
                  :currentActiveIndex="currentActiveSourceIndex"
                  :currentActivePickupIndex="currentActivePickupIndex"
                  :selectionInProgress="showSourceSlider"
                  :sourceConfig="getCreateConfigForSource"
                  :hideAllActions="isOnlyChangeTruckState || isEximIndent"
                  :maxSelectionAllowed="getSourceMaxSelectionAllowed"
                  :transporterPaneOpen="transporterPaneOpen"
                  @deletePickup="deletePickup"
                  @deleteSource="deleteSource"
                  @changeCurrentActiveSource="changeCurrentActiveSource"
                  @addNewSource="openAddSourceSlider"
                />
              </div>
              <div class="card-right" :class="{'collapsed': transporterPaneOpen}">
                <div class="status-msg" v-if="!currentActiveSourceData">
                  <span class="p-0">
                    <svgicon name="empty-dropoffs" width="100" height="90" :original="true" />
                    <p>{{$t('INDENT_BUILD_INDENT')}}</p>
                  </span>
                </div>
                <span v-else>
                  <div
                    class="card-content with-hover p-0"
                    v-for="(pickup,index) in currentActiveSourceData.pickups"
                    :class="{'card-shadow': index === currentActivePickupIndex}"
                    :key="index"
                    @click="currentActivePickupIndex = index" >
                    <!-- pickup Form for add/update pickups and dropoffs - Middle pane -->
                    <pickup-form
                      :transporterPaneOpen="transporterPaneOpen"
                      :data="pickup"
                      :depot="currentActiveSourceData"
                      :list="currentActiveSourceData.gates"
                      :showPickups="showGates"
                      :index="index"
                      :selectedGateIds="selectedGateIds"
                      :selectedOrderType="currentOrderDetails.type.name"
                      :extendSlaBy="extendSlaBy"
                      :isHideAllActions="isOnlyChangeTruckState"
                      :isHideEditDropOffSource="isEximIndent"
                      :destinationConfig="getCreateConfigForDrops"
                      :slaJobData="order.sla_job_data"
                      :datePickerFormat="datePickerFormat"
                      :isEditState="isEditState"
                      :selectedOrderStatus="currentOrderDetails.status"
                      :orderMovement="order.movement"
                      :selectedOrderDeliveryType="currentOrderDetails.deliveryType"
                      :autoSwitchExtendedOnce="order.auto_switch_extended_once"
                      :clientConfig="configurations"
                      @deletePickup="deletePickup(index)"
                      @changePickupData="editPickup($event, index)"
                      @addEditDropoffs="addEditDropoffs($event,pickup)"
                      @openDropoffSlider="openDropoffSlider(index)"
                      @deleteDropoff="deleteDropoff($event,pickup)"
                      @setGA="setGA"
                      @editConsignee="editConsignee"
                      @sla-change="updateSla"
                    />
                  </div>
                  <div
                    v-if="(showGates && canAddPickup) && !isOnlyChangeTruckState && !isEximIndent"
                    class="card-box-plain is-dotted pointer"
                    :class="{'event-disabler': transporterPaneOpen }"
                    @click="addNewPickup()"
                  >
                    <h6 class="mb-0">
                      {{$t('INDENT_ADD_PICKUP')}}
                      <small>{{$t('INDENT_CLICK_ADD_PICKUP')}}</small>
                    </h6>
                  </div>
                </span>
              </div>
            </div>
          </Tab-pane>
        </ElTabs>
      </div>

      <!-- Selection Transporter, Delivery Type, Vehicle, additional Info(Purchase order)  -->
      <div class="default-slider slider-dark" :class="{'with-footer': totalConsolidatedPickups || (isMarketIndent && transitDays)}" direction="right">
        <Details
          ref="indentDetails"
          :selectedTransporterName="selectedTransporterName"
          :sourcesDropOffs="sourcesDropOffs"
          :disableIndentButton="disableIndentButton"
          :vehicles="contractVehicles"
          :currentActiveSourceIndex="currentActiveSourceIndex"
          :currentIndent="currentOrderDetails"
          :showMasterData="!isContract"
          :count="totalConsolidatedPickups"
          :hasOpenRfqIndentConfig="hasOpenRfqIndentConfig"
          :hasPurchaseOrderConfig="hasPurchaseOrderConfig"
          :purchaseOrderFields="purchaseOrderFields"
          :purchaseOrderFieldsListData="purchaseOrderFieldsListData"
          :isPoOrderTypeEnabled="isPoOrderTypeEnabled"
          :transitDays="isMarketIndent && transitDays"
          :isOnlyChangeTruckState="isOnlyChangeTruckState"
          :hideAllActions="!canEditDetails"
          :isEximIndent="isEximIndent"
          :isEditState="isEditState"
          :isFromCloneState="isFromCloneState"
          :isCreateFromDraftState="isCreateFromDraftState"
          :isFromEximList="isFromEximList"
          :showIndentPrompt="showIndentPrompt"
          :showIndentPromptDropLimit="showIndentPromptDropLimit"
          :IndentPromptLimit="configurations.max_drop_allowed_count_for_ptl"
          :selectedType="selectedType"
          :isOutbound="isOutboundIndent"
          @clearIndentDetails="clearIndentDetails"
          @createIndent="createUpdateEventHelper($event)"
          @disableIndentPromptDropLimit="showIndentPromptDropLimit=false"
          @changeIndentDetails="changeIndentDetails"
          @freightUpdated="freightUpdated"
          @searchPurchaseOrder="searchPurchaseOrder"
          @closeIndentPrompt="showIndentPrompt = false"
          @hide-transporter-slider="hideTransporterPane"
          @open-transporter-slider="openTransporterPane"
          @allTransportersSelected="toggleAllTransportersSelected"
          @updateTransporterName="updateTransporterName"
          @change-contract-vehicles="changeContractVehicles"
          @set-order-type="setOrderType"
          @reset-freight="resetFreight"
          @update-sequence-data="updateSequenceData"
        />
      </div>
      <!-- drawer for addition of source -->
      <Drawer
        :visible.sync="showSourceSlider"
        direction="rtl"
        size="740px"
        modal-wrapper="false"
        :withHeader="false"
        :wrapperClosable="false"
        class="default-drawer"
      >
        <add-source
          v-if="showSourceSlider"
          :sourceConfig="getCreateConfigForSource"
          :selectedSourceIds="selectedSourceIds"
          :isEditState="isEditState"
          :existingSelectedType="selectedType"
          :currentIndentType="getCurrentIndentType.name"
          @closeSourceSlider="closeAddSourceSlider"
          @addNewSource="addNewSource"
          @setGA="setGA"
        />
      </Drawer>

      <!-- drawer for add/edit destination -->
      <Drawer
        v-if="currentActivePickupData"
        :visible.sync="showDropoffSlider"
        direction="rtl"
        size="900px"
        modal-wrapper="false"
        :withHeader="false"
        :wrapperClosable="false"
        class="default-drawer"
      >
        <add-edit-dropoff
          :data="currentActivePickupData.dropoffs"
          :destinationConfig="getCreateConfigForDrops"
          :sourceId="currentActiveSourceData.id"
          :sourcesDropOffs="sourcesDropOffs"
          :selectedPickupData="currentActivePickupData"
          :orderType="currentOrderType"
          :skipContractCheck="!canEditDetails"
          :maxSelectionAllowed="destinationMaxSelectionAllowed"
          :isEditState="isEditState"
          @closeDropoffSlider="closeDropoffSlider"
          @addEditDropoffs="addEditDropoffs"
          @changeContractVehicles="changeContractVehicles"
          @setOrderType="setOrderType"
          @setGA="setGA"
          @reset-freight="resetFreight"
        />
      </Drawer>

      <!-- Dialog box for truck congestion-->
      <Dialog :visible.sync="showVehicleCongestion" width="30%" center class="dialogbox alertbox_content">
        <div class="box">
          <div class="dialogbox-title">{{$t('INDENT_LIKELY_CONGESTION')}}</div>
          <div class="dialogbox-body">
            <div class="dialogbox-content">
              <p
                v-for="(vehicleCongestionLoop, index) in vehicleCongestionIn"
                v-bind:key="index"
                class="content_text"
              >
                {{$t('INDENT_VEHICLE_CONGESTION_MSG', { name: vehicleCongestionLoop.name ,
                 time: $moment(vehicleCongestionLoop.expectedDeliveryDate).format('DD MMM YYYY')})}}
              </p>

              <p
                class="content_text"
              >{{$t('INDENT_SAME_VRD_PROMPT_MSG')}}</p>
            </div>
          </div>
          <div class="dialogbox-footer">
            <button
              type="btn"
              @click="showVehicleCongestion = false"
              class="btn btn-secondary"
            >
              {{$t('INDENT_NO')}}
            </button>
            <button
              type="btn"
              @click="createOrUpdateIndent(true)"
              class="btn btn-primary"
            >{{$t('INDENT_YES')}}
            </button>
          </div>
        </div>
      </Dialog>
      <Drawer
        :visible.sync="editConsigneeSlider"
        direction="rtl"
        size="400px"
        :withHeader="false"
        :modal="true"
        :append-to-body="true"
        class="default-drawer"
      >
        <Link :underline="false" class="nav-close" @click="editConsigneeSlider=false">
          <svgicon name="cancelwhite" width="12" height="12" :original="true" />
        </Link>
        <ConsigneeEdit
        v-if="selectedConsigneeData"
        :data="selectedConsigneeData"
        @closeEditConsigneeSlider="closeEditConsigneeSlider"
        @updateConsignee="updateConsignee"
        />
      </Drawer>

      <!-- Dialog box for indent update reason -->
      <Dialog
      :title="$t('INDENT_EDIT_POPUP_TITLE')"
      :visible.sync="showIndentUpdateDialog"
      width="450px"
      top="6vh"
      :show-close="true"
      :before-close="logout"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      custom-class="indent-update-dialog"
      class="default-dialog">
      <p class="content_text">Please select the reason to update the changes</p>
      <div class="dialog-content dialog-scroll">
      <Form  class="form-default mr-5">
          <FormItem label="REASON TO UPDATE" :required="true">
            <Select v-model="indentUpdateReason.data"
              @change="indentUpdateReason.custom =''"
                placeholder="Select Reason" size="mini" class="select-default content_text">
              <Option
                v-for="item in indentUpdateOptions"
                :key="item.key"
                :value="item.value">
                <Ellipsis
                  :text="item.value"
                  :length="50"
                />
              </Option>
            </Select>
          </FormItem>
          <div v-if="indentUpdateReason.data === $t('OTHERS')">
            <FormItem :label="$t('OTHERS')" :required="true">
              <Input :placeholder="$t('INDENT_ENTER_REASON') + ' (Minimum 15 character required)'"
                :maxlength="150"
                :minlength="15"
                :rows="2"
                type="textarea"
                class="form-control" v-model="indentUpdateReason.custom"></Input>
            </FormItem>
          </div>
      </Form>
      </div>
      <span slot="footer" class="dialog-footer">
        <Button type="secondary" size="mini" @click="showIndentUpdateDialog=false;">
          {{ $t('CANCEL') }}
        </Button>
        <Button type="primary" size="mini" :disabled="!canUpdate"
          @click="createUpdateEventHelper(createOrUpdateEvent, true);">
          {{$t('INDENT_SUBMIT')}}
        </Button>
      </span>
    </Dialog>

    <!-- Dialog box for freight update confirmation -->
    <Dialog
      :title="$t('INDENT_CONFIRMATION')"
      :visible.sync="showFreightConfirmationPopUp"
      width="450px"
      top="6vh"
      :show-close="true"
      :before-close="logout"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      custom-class="indent-update-dialog"
      class="default-dialog">
      <p class="content_text">
        {{ $t('FREIGHT_RATE_CONFIRMATION_MSG', { freight_rate: this.currentOrderDetails.freightRate,
          freight_unit: this.getFreightUnit }) }}
      </p>
      <p class="content_text"> {{$t('DO_YOU_WANT_TO_PROCEED')}} </p>
      <span slot="footer" class="dialog-footer">
        <Button type="secondary" size="mini" @click="showFreightConfirmationPopUp=false;">
          {{ $t('CANCEL') }}
        </Button>
        <Button type="primary" size="mini"
          @click="createOrUpdateIndent(false, createOrUpdateEvent);">
          {{$t('INDENT_SUBMIT')}}
        </Button>
      </span>
    </Dialog>
    </div>

  </div>
</template>
<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import moment from 'moment';
import { mapGetters } from 'vuex';
import { uniqBy, cloneDeep } from 'lodash';
// eslint-disable-next-line import/no-extraneous-dependencies
import {
  sourceAndDestinationType, orderType,
  defaultDestinationPriorityType, minTransportersCountForRFQ,
  indentCreateUpdateErrors, deliveryTypes,
} from 'pando-constants';
import {
  CreateConfig,
  orderTypes,
  indentTypes,
} from '@/modules-v2/indent/constants/order';
import { indentEditOptions } from '@/constants/reason-settings';

import { getTransitDays } from '@common/lib/market-place';
import { isContract, isOpen, isMarket, isNoFreight } from '@common/lib/order';
import { OpenIndentcontractTypes as contractTypes } from '@/constants/order';

import SourceList from '@/modules-v2/indent/components/create-update/source-list';
import PickupForm from '@/modules-v2/indent/components/create-update/pickup-form';
import ConsigneeEdit from '@/modules-v2/indent/components/create-update/indent-edit-consignee';
import AddSource from '@/modules-v2/indent/views/create-update/add-source';
import AddEditDropoff from '@/modules-v2/indent/views/create-update/add-edit-dropoff';
import Details from '@/modules-v2/indent/views/create-update/details';

import ContractCheck from '@/modules-v2/indent/mixins/create-update/contract-check';
import EditState from '@/modules-v2/indent/mixins/create-update/edit-state';
import { getVehicleRequirementDate } from '@/lib/Date';

export default {
  mixins: [ContractCheck, EditState],
  components: {
    SourceList,
    PickupForm,
    AddSource,
    AddEditDropoff,
    Details,
    ConsigneeEdit,
  },
  data() {
    return {
      order: {}, // order details in case of edit/change truck type
      showTransporterSlider: true,
      // slider variables for selection of sources and dropoffs
      showSourceSlider: false,
      showDropoffSlider: false,

      // current selections of the user
      currentActiveSourceIndex: 0,
      currentActivePickupIndex: -1,
      selectedOrderType: {},

      // consolidated data of sources and dropoffs
      sourcesDropOffs: [],

      // other order details like vehicle, transporter , delivery type
      currentOrderDetails: {},
      previousTransporterId: '',
      // details dropdown
      contractVehicles: [], // vehicles and corresponding transporters in contract
      allowedOrderTypes: [], // allowed order types based on permission

      // constants imported
      CreateConfig,
      sourceAndDestinationType,

      // vehicle congestion
      showVehicleCongestion: false,
      vehicleCongestionIn: [],
      isVehicleRequirementDateChanged: false,

      selectedType: null, // holds the previous selected destType
      sourceMaxSelectionAllowed: 100,
      indentCutOff: 0,
      indentArrivalCutOff: 0,

      // draft indent variables
      isSaveDraftedState: false, // in indent add to save draft

      /*
        purchase order variables
      */
      // dropdown data
      purchaseOrderFieldsListData: {
        po_number: [],
        po_line_number: [],
        account_assignment_number: [],
      },
      hasPurchaseOrderConfig: false,
      purchaseOrderFields: [],
      purchaseOrderEnabledForOrderType: [],

      // edit consignee related data
      editConsigneeSlider: false,
      selectedConsigneeData: null,
      extendSlaBy: 0,

      // open-rfq related data
      showIndentPrompt: false,
      transportersValidated: false,

      // Drop limit with clientconfig
      showIndentPromptDropLimit: false,
      transporterPaneOpen: false,
      allTransportersSelected: false,
      selectedTransporterName: '',
      pickupDropSequence: null,
      showIndentUpdateDialog: false,
      showFreightConfirmationPopUp: false,
      isFreightUpdated: false,
      contractTypes,
      createOrUpdateEvent: null,
      indentUpdateReason: {
        custom: '',
        data: '',
      },
      indentUpdateOptions: [],
      isProcess: false,
    };
  },
  async created() {
    this.$store.commit('indentV2/initialReset');
    this.allowedOrderTypes = orderTypes.filter((orderType) => {
      if (this.$hasPermission('exclusive_draft_indent_creation')) {
        return true;
      }
      if (!this.isInbound || (this.isInbound && orderType.id !== 3)) {
        return this.$hasPermission(orderType.create_permission);
      }
    });
    this.currentOrderDetails.type = this.allowedOrderTypes[0];
    // Fetch indent bootstrap data from store or API if not already available
    const result = await this.getIndentBoostrap();
    this.hasPurchaseOrderConfig = result && result.po_indent_config
       && result.po_indent_config.map_purchase_order_to_indent;
    if (this.hasPurchaseOrderConfig) {
      this.purchaseOrderEnabledForOrderType.push(...result.po_indent_config.enabled_for);
      this.purchaseOrderFields.push(...result.po_indent_config.config_field);
    }

    if (this.isEditState || this.isCreateFromDraftState || this.isFromCloneState) {
      await this.bootStrapEditState();
      this.extendSlaBy = this.currentOrderDetails.extend_sla_by;
      this.selectedType = (this.sourcesDropOffs) ? this.sourcesDropOffs[0].type.toString() : null;
      if ((isOpen(this.currentOrderDetails.type.name) || this.isContract || this.isNoFreightIndent) && this.currentOrderDetails.transporterName) {
        this.selectedTransporterName = this.currentOrderDetails.transporterName;
      }
      if (this.hasPurchaseOrderConfig && this.isPoOrderTypeEnabled &&
        this.currentOrderDetails.transporterId) {
        await this.getPurchaseOrderFieldsListData(this.currentOrderDetails);
      }
    } else {
      await this.prepopulateSources();
    }
  },

  computed: {
    ...mapGetters({
      configurations: 'app/configurations',
      depots: 'app/otherDepots',
      masterVehiclesList: 'indentV2/masterVehiclesList', // all vehicle types list
      masterTransportersList: 'indentV2/masterTransportersList', // all transporter list
      indentBootstrap: 'indentV2/indentBootstrap',
    }),
    getFreightUnit() {
      const freightUnit = this.contractTypes.find(type =>
        type.id === this.currentOrderDetails.open_freight_type);
      return (freightUnit && freightUnit.name) || null;
    },
    isOutboundIndent() {
      return this.getCurrentIndentType.name === 'OUTBOUND';
    },
    getCreateConfigForSource() {
      if (this.isOutboundIndent && (!this.$hasFeature('last_mile') ||
        ![orderType.CONTRACT, orderType.OPEN].includes(this.currentOrderDetails.type.id))) {
        const createConfig = [...CreateConfig[this.getCurrentIndentType.name].source];
        createConfig.pop();
        return createConfig;
      }
      return CreateConfig[this.getCurrentIndentType.name].source;
    },
    getCreateConfigForDrops() {
      const hasConsigneeAtSource = this.currentActiveSourceData
        ? Number(this.currentActiveSourceData.type) === this.sourceAndDestinationType.CONSIGNEE
        : false;
      if (this.isOutboundIndent && this.$hasFeature('last_mile') && hasConsigneeAtSource) {
        const createConfig = [...CreateConfig[this.getCurrentIndentType.name].destination];
        createConfig.pop();
        return createConfig;
      }
      return CreateConfig[this.getCurrentIndentType.name].destination;
    },
    getOptimaInfo() {
      return this.order && this.order.optima_info ? this.order.optima_info : false;
    },
    getSelectedpickupType() {
      return this.sourcesDropOffs.length ?
        this.sourcesDropOffs.find(source => source.type).type :
        null;
    },
    getSourceMaxSelectionAllowed() {
      try {
        if (this.configurations && this.configurations.multi_pickup_max_count && this.sourcesDropOffs.length) {
          const movementObj = defaultDestinationPriorityType()
            .find(movement => movement.destinationType === parseInt(this.getSelectedpickupType, 10))
            .source;
          return this.configurations.multi_pickup_max_count[movementObj];
        } return 1;
      } catch (error) {
        return error;
      }
    },
    routeToIndents() {
      const type = this.$route.params.type || 0;
      if (parseInt(type, 10) === 0) {
        return { name: 'OutboundIndents' };
      }
      return { name: 'InboundIndents' };
    },
    datePickerFormat() {
      return (this.configurations && this.configurations.is_datepicker_24H_enabled) ? 'dd-MM-yyyy HH:mm' : 'dd-MM-yyyy hh:mmA';
    },
    isVendorMovement() {
      return (this.sourcesDropOffs && this.sourcesDropOffs[0].type.toString() === sourceAndDestinationType.VENDOR_DEPOT.toString()) || false;
    },
    destinationMaxSelectionAllowed() {
      // Multi drop not allowed
      if (this.isEditState && this.currentOrderDetails.deliveryType === deliveryTypes.PTL &&
        this.$hasFeature('restrict_multi_drop_for_ptl')) {
        return 1;
      }
      if (this.getCurrentIndentType.name === 'OUTBOUND') {
        return 100;
      }
      return this.isVendorMovement ? 100 : 1;
    },
    /** exim road leg methods */
    isFromEximList() {
      return this.$route && this.$route.query && this.$route.query.isFromEximList === 'true';
    },
    masterIndentType() {
      return this.currentOrderDetails && (this.currentOrderDetails.exim_type === 1 ? 'Export' : 'Import');
    },
    /** end of exim road leg methods */
    getGAEventCategory() {
      const actionName = this.isEditState ? 'Edit' : 'Add';
      const indenttype = this.getCurrentIndentType.name.toLowerCase();
      return `${actionName} ${indenttype} Indent`;
    },
    isOnlyChangeTruckState() {
      return (this.$route && this.$route.meta) &&
        this.$route.meta.allowChangeTruck;
    },
    isCreateFromDraftState() {
      return (this.$route && this.$route.meta) &&
        this.$route.meta.isFromDraft;
    },

    isFromCloneState() {
      return (this.$route && this.$route.meta) &&
        this.$route.meta.isFromClone;
    },
    disableChangeOrderType() {
      if (this.transporterPaneOpen) {
        return true;
      }
      return (this.isCreateFromDraftState || this.isFromCloneState) ? false : this.isEditState;
    },
    isEditState() {
      return this.$route.params && this.$route.params.orderId != null
      && !this.isFromCloneState && !this.isCreateFromDraftState;
    },

    isEximIndent() {
      return this.order && this.order.exim_type && this.$hasFeature('exim_enabled');
    },

    // OUTBOUND or INBOUND
    getCurrentIndentType() {
      const type = this.$route.params.type || 0;
      return (
        indentTypes.find(_type => parseInt(type, 10) === _type.id) ||
        indentTypes[0]
      );
    },

    /**
     * Config check computed methods
     */
    hasOpenRfqIndentConfig() {
      return this.configurations && this.configurations.open_indent_rfq;
    },

    isUnloadingCapacityEnabled() {
      return (
        this.configurations &&
        this.configurations.unloading_capacity &&
        this.configurations.unloading_capacity.enable
      );
    },

    /**
     * Order Type computed functions
     */
    isContract() {
      return (
        this.currentOrderDetails && this.currentOrderDetails.type &&
        isContract(this.currentOrderDetails.type.name)
      );
    },
    isPoOrderTypeEnabled() {
      if (this.currentOrderDetails && this.currentOrderDetails.type) {
        return this.purchaseOrderEnabledForOrderType.includes(this.currentOrderDetails.type.id);
      }
      return false;
    },
    isMarketIndent() {
      return (
        this.currentOrderDetails && isMarket(this.currentOrderDetails.type.name)
      );
    },
    isNoFreightIndent() {
      return (
        this.currentOrderDetails &&
        isNoFreight(this.currentOrderDetails.type.name)
      );
    },

    currentOrderType() {
      return (
        this.currentOrderDetails.type && this.currentOrderDetails.type.name
      );
    },

    /**
     * Source related computed functions
     */
    noSourcesSelected() {
      return !this.sourcesDropOffs || !this.sourcesDropOffs.length;
    },

    currentActiveSourceData() {
      return this.sourcesDropOffs && this.sourcesDropOffs[this.currentActiveSourceIndex];
    },

    selectedSourceIds() {
      return this.sourcesDropOffs && this.sourcesDropOffs.map(val => val.id);
    },
    selectedSourceType() {
      return this.sourcesDropOffs && this.sourcesDropOffs.map(val => val.id);
    },

    /**
     * Dropoff related computed functions
     */
    // dropoff selection in progress or no dropoffs selected
    noDropOffsSelected() {
      return this.noSourcesSelected
        ? true
        : this.sourcesDropOffs.some(
          source =>
            !source.pickups ||
              source.pickups.some(
                pickup => !pickup || !pickup.dropoffs || !pickup.dropoffs.length,
              ),
        );
    },
    isAtleastOneDropSelected() {
      return (
        !this.noSourcesSelected &&
        this.sourcesDropOffs.some(
          source =>
            source.pickups &&
            source.pickups.some(
              pickup => pickup && pickup.dropoffs && pickup.dropoffs.length,
            ),
        )
      );
    },

    /**
     * Pickup or gate related computed functions
     */
    currentActivePickupData() {
      const sourceIndex = this.currentActiveSourceIndex;
      return (
        this.currentActivePickupIndex !== -1 &&
          this.sourcesDropOffs[sourceIndex] &&
          this.sourcesDropOffs[sourceIndex].pickups[
            this.currentActivePickupIndex
          ]
      );
    },
    showGates() {
      return this.hasGatesByType(
        this.sourcesDropOffs[this.currentActiveSourceIndex].type,
      );
    },
    canAddPickup() {
      return (
        this.selectedGateIds.length !==
        this.currentActiveSourceData.gates.length
      ) && (!(this.isEditState && this.currentOrderDetails.deliveryType === deliveryTypes.PTL
        && this.$hasFeature('restrict_multi_drop_for_ptl')));
    },

    selectedGateIds() {
      const pickups = this.sourcesDropOffs[this.currentActiveSourceIndex]
        .pickups;
      return pickups && pickups.map(val => val.id);
    },

    // count of total pickups across sources
    totalConsolidatedPickups() {
      return this.sourcesDropOffs &&
        this.sourcesDropOffs.reduce((acc, source) => acc + ((source.pickups && source.pickups.length) || 0), 0);
    },

    /**
     * Indent related computed methods
     */
    disableIndentButton() {
      const purchaseOrderDisable = this.isPoOrderTypeEnabled && this.hasPurchaseOrderConfig
      && (!this.currentOrderDetails.purchaseOrderId
      || !this.currentOrderDetails.po_number || !this.currentOrderDetails.account_assignment_number
      || !this.currentOrderDetails.po_line_number);
      let shipmentNumberDisable = false;
      shipmentNumberDisable = this.$hasFeature('allow_shipment_number') && !this.currentOrderDetails.shipment_number;
      return (
        this.noSourcesSelected ||
        this.noDropOffsSelected ||
        this.checkSelectedTransportersCount ||
        (!this.isMarketIndent && !this.currentOrderDetails.transporterId) ||
        (purchaseOrderDisable) || shipmentNumberDisable
      );
    },

    transitDays() {
      if (this.noDropOffsSelected) {
        return 0;
      }
      const vehicleRequirementDatesArray = this.sourcesDropOffs.reduce(
        (acc, source) => acc.concat(
          source.pickups.reduce((acc, pickup) => acc.concat(pickup.vehicle_requirement_date || new Date()), []),
        ),
        [],
      );

      const vehicleRequirement = new Date(
        moment.min(vehicleRequirementDatesArray),
      );

      const expectedDatesArray = this.sourcesDropOffs.reduce((acc, source) => acc.concat(
        source.pickups.reduce((acc, pickup) => acc.concat(
          pickup.dropoffs.reduce((acc, drop) => acc.concat(moment(drop.expected_date) || new Date()), []),
        ), []),
      ), []);

      const expectedDelivery = new Date(moment.max(expectedDatesArray));

      const noOfDays = getTransitDays(expectedDelivery, vehicleRequirement);
      return noOfDays;
    },
    /**
     * EDIT based computed methods
     */
    canEditDetails() {
      if (!this.isEditState) {
        return true;
      } else if (this.currentOrderDetails.hasOwnProperty('status')) {
        return (this.$statusUtil.getMainStatusName(this.currentOrderDetails.status) === 'indented') ||
          (this.$statusUtil.getMainStatusName(this.currentOrderDetails.status) === 'drafted');
      }
      return false;
    },
    checkSelectedTransportersCount() {
      // Minimum 2 transporters to be selected to Request for RFQ Indent
      if (this.currentOrderDetails.rfq && !this.isNoFreightIndent && !this.isMarketIndent) {
        if (typeof (this.currentOrderDetails.transporterId) === 'string' || !this.currentOrderDetails.transporterId || this.currentOrderDetails.transporterId.length < minTransportersCountForRFQ) {
          return true;
        }
      }
      return false;
    },
    canUpdate() {
      return this.isEditState && ((this.indentUpdateReason.data && this.indentUpdateReason.data !== 'Others'
      && !this.indentUpdateReason.custom)
      || (this.indentUpdateReason.data === 'Others' && this.indentUpdateReason.custom.length >= 15));
    },
  },
  methods: {
    toggleAllTransportersSelected(val) {
      this.allTransportersSelected = val;
    },
    hideTransporterPane() {
      this.transporterPaneOpen = false;
    },
    openTransporterPane() {
      this.transporterPaneOpen = true;
    },
    resetFreight() {
      this.currentOrderDetails.freightRate = 0;
    },
    updateSla(data) {
      this.extendSlaBy = data;
    },
    async getIndentBoostrap() {
      if (this.indentBootstrap && Object.keys(this.indentBootstrap).length > 0) {
        return this.indentBootstrap;
      }
      const indentBootstrap = await this.$store.dispatch('indentV2/indentBootstrap');
      return indentBootstrap;
    },
    /**
     Edit Consignee Related Methods
     * */
    async editConsignee(consignee) {
      try {
        this.selectedConsigneeData = null;
        this.editConsigneeSlider = true;
        const consigneeId = consignee && consignee.ship_to && consignee.ship_to.id;
        this.selectedConsigneeData = await this.$store.dispatch('indentV2/getConsigneeData', consigneeId);
      } catch (err) {
        this.$errorMessage({ message: this.$t('APP_CATCH_ERR') });
      }
    },
    closeEditConsigneeSlider() {
      this.editConsigneeSlider = false;
    },
    async updateConsignee(payload, consigneeId) {
      try {
        const result = await this.$store.dispatch('indentV2/updateConsigneeData', { payload, consigneeId });
        if (result && result.id) {
          this.$successMessage({ message: this.$getSuccess('CONSIGNEE_UPDATE') });
          this.closeEditConsigneeSlider();
          if (this.isContract) {
            const contractCheckSuccess = await this.checkContract();
            if (!contractCheckSuccess) {
              const dispalayCancelButton = false;
              const showCloseButton = false;
              const userResponse = await this.openSwitchOpenIndentDialog(dispalayCancelButton,
                showCloseButton);
              if (userResponse) {
                this.resetFreight();
              }
            }
          }
        } else if (result && result.error) {
          this.$errorMessage({
            message: result.error,
          });
        }
      } catch (err) {
        this.$errorMessage({ message: this.$t('APP_CATCH_ERR') });
      }
    },
    /**
     * SOURCE RELATED METHODS
     */
    async prepopulateSources() {
      if (this.getCurrentIndentType.name === 'OUTBOUND') {
        const sourceConfig = this.CreateConfig[this.getCurrentIndentType.name]
          .source[0];
        const params = { page: 1 };
        const depotsList = await this.$store.dispatch(sourceConfig.storeCallPath, params);
        if (depotsList && depotsList.length === 1) {
          const source = depotsList[0];
          const sourceDetails = { city: source.city,
            name: source.name,
            reference_id: source.reference_id,
            id: source.id,
            gates: source.gates.filter(gate => !gate.is_virtual_gate),
            type: this.sourceAndDestinationType.DEPOT };
          this.addNewSource(sourceDetails);
        }
      }
    },
    // selection of the source to show the pickup details
    changeCurrentActiveSource(sourceIndex) {
      this.currentActiveSourceIndex = sourceIndex;
    },

    // add new source slider actions
    openAddSourceSlider() {
      this.showSourceSlider = true;
    },
    closeAddSourceSlider() {
      this.showSourceSlider = false;
    },

    // adding additional source
    addNewSource(source, typesToDelete = null) {
      this.selectedType = source.type ? source.type.toString() : source.type;

      if (typesToDelete) {
        this.sourcesDropOffs = this.sourcesDropOffs.filter(
          source => !typesToDelete.includes(parseInt(source.type, 10)),
        );
      }
      let pickupsData = [{}];
      if (source.gates &&
        (source.gates.length === 1 || this.$hasFeature('default_gate_selection'))) {
        const gate = source.gates[0];
        pickupsData = [
          {
            id: gate.id,
            reference_id: gate.reference_id,
            name: gate.name,
          },
        ];
      }
      this.sourcesDropOffs.push({ ...source, ...{ pickups: pickupsData } });
      this.sourcesDropOffs = [...this.sourcesDropOffs];
      this.currentActiveSourceIndex = this.sourcesDropOffs.length - 1;
      this.clearIndentDetails(true);
    },

    // deleting the source details at index 'sourceIndex'
    deleteSource(sourceIndex) {
      this.sourcesDropOffs = this.sourcesDropOffs.filter(
        (val, index) => index !== sourceIndex,
      );
      this.currentActiveSourceIndex = sourceIndex !== 0 ? sourceIndex - 1 : 0;
      this.currentActivePickupIndex = 0;
      this.clearIndentDetails(true);
      if (this.sourcesDropOffs.length === 0) this.selectedType = null;
    },

    /**
     * PICKUP RELATED METHODS
     */
    // adding pickup to the current active source
    addNewPickup(sourceIndexInput = null) {
      const sourceIndex = sourceIndexInput === null ? this.currentActiveSourceIndex : sourceIndexInput;
      const data = this.sourcesDropOffs;
      data[sourceIndex].pickups.push({});
      this.currentActivePickupIndex = data[sourceIndex].pickups.length - 1;
      this.sourcesDropOffs = [...data];
      this.clearIndentDetails(true);
    },

    // edit the pickup of the current active source
    async editPickup(value, pickupIndex, sourceIndexInput = null) {
      const sourceIndex = sourceIndexInput === null ? this.currentActiveSourceIndex : sourceIndexInput;
      let hasContractCheck = false;

      const currentPickup = this.sourcesDropOffs[sourceIndex].pickups[pickupIndex];
      if (value.id && currentPickup.id && currentPickup.id !== value.id) {
        hasContractCheck = true;
      }
      if (currentPickup && currentPickup.vehicle_requirement_date !== value.vehicle_requirement_date) {
        this.isVehicleRequirementDateChanged = true;
      }
      this.sourcesDropOffs[sourceIndex].pickups[pickupIndex] = value;
      this.sourcesDropOffs[sourceIndex].pickups[pickupIndex].dropoffs = value.dropoffs &&
        value.dropoffs.filter(drop => drop.ship_to.id !== value.id);
      this.sourcesDropOffs = [...this.sourcesDropOffs];

      if (currentPickup && currentPickup.vehicle_requirement_date !== value.vehicle_requirement_date) {
        this.sourcesDropOffs[sourceIndex].pickups[pickupIndex].dropoffs =
          currentPickup.dropoffs.map(dropoff => ({
            ...dropoff,
            ...{ expected_date: value.vehicle_requirement_date },
          }));
      }

      this.currentActivePickupIndex = pickupIndex;
      let contractCheckSuccess = true;

      if (hasContractCheck && this.isContract && this.canEditDetails) {
        contractCheckSuccess = await this.checkContract();
        if (!contractCheckSuccess) {
          this.sourcesDropOffs[sourceIndex].pickups[pickupIndex].dropoffs = [];
        }
      }
      this.clearIndentDetails(true);
    },

    // delete the pickup of a source
    async deletePickup(pickupIndex, sourceIndexInput = null) {
      const sourceIndex = sourceIndexInput || this.currentActiveSourceIndex;
      const sourceData = [...this.sourcesDropOffs];
      sourceData[sourceIndex].pickups = sourceData[sourceIndex].pickups.filter(
        (val, index) => index !== pickupIndex,
      );
      if (sourceData[sourceIndex].pickups[pickupIndex] && sourceData[sourceIndex].pickups[pickupIndex].id) {
        const dockList = this.$depot.docksByGate(sourceData[sourceIndex].pickups[pickupIndex].id);
        const currentDockIds = dockList.filter(dock =>
          sourceData[sourceIndex].pickups[pickupIndex].dockId.includes(dock.id)).map(dock => dock.id);
        sourceData[sourceIndex].pickups[pickupIndex].dockId = currentDockIds;
      }
      let contractCheckSuccess = true;
      if (this.canEditDetails) {
        if (this.isContract) {
          contractCheckSuccess = await this.checkContract();
          if (!contractCheckSuccess) {
            this.sourcesDropOffs[sourceIndex].pickups[pickupIndex].dropoffs = [];
          }
        }
        this.clearIndentDetails(true);
      }
    },

    /**
     * DROPOFFS related methods
     */
    // DROPOFFS(destination) drawer actions
    openDropoffSlider(pickupIndex) {
      this.currentActivePickupIndex = pickupIndex;
      this.showDropoffSlider = true;
    },
    closeDropoffSlider() {
      this.showDropoffSlider = false;
      this.currentActivePickupIndex = -1;
    },

    // adding or editing dropoffs
    addEditDropoffs(dropoffData, pickupData = null) {
      const selectedPickupData = pickupData || this.currentActivePickupData;
      const pickupIndex = this.sourcesDropOffs[
        this.currentActiveSourceIndex
      ].pickups.findIndex(val => val.id === selectedPickupData.id);
      const value = { ...selectedPickupData, ...{ dropoffs: dropoffData } };
      this.editPickup(value, pickupIndex);
      this.closeDropoffSlider();
      this.clearIndentDetails(true);
    },
    hasGatesByType(type) {
      const sourceConfig = this.CreateConfig[this.getCurrentIndentType.name]
        .source;
      const configByType = sourceConfig.find(
        val => val.type === parseInt(type, 10),
      );
      return configByType && configByType.hasGates;
    },
    async deleteDropoff(dropoffData, pickupData = null) {
      const selectedPickupData = pickupData || this.currentActivePickupData;
      const pickupIndex = this.sourcesDropOffs[
        this.currentActiveSourceIndex
      ].pickups.findIndex(val => val.id === selectedPickupData.id);
      let dropoffsData;
      if (this.isFromCloneState || this.isEditState) {
        dropoffsData = selectedPickupData.dropoffs.filter(
          val => val.index !== dropoffData.index,
        );
      } else {
        dropoffsData = selectedPickupData.dropoffs.filter(
          val => val.indexedAt !== dropoffData.indexedAt,
        );
      }
      const value = { ...selectedPickupData, ...{ dropoffs: dropoffsData } };
      this.editPickup(value, pickupIndex);
      if (this.isContract && dropoffsData.length) {
        await this.checkContract();
      } else {
        await this.changeContractVehicles([]);
      }
      this.clearIndentDetails(true);
    },
    /*
      PURCHASE ORDER RELATED FUNCTIONS
    */

    getDropdownPurchaseOrderData(poData = []) {
      return poData.map(_po =>
        (
          {
            id: _po.id,
            po_number: _po.po_number,
            account_assignment_number: _po.account_assignment_number,
            po_line_number: _po.po_line_number,
          }
        ),
      );
    },

    // purchase order fields dropdown data construction
    constructPurchaseOrderDataAndAutoPopulate(poData, label, poDataAPI = []) {
      const purchaseOrderData = this.getDropdownPurchaseOrderData(poData);
      // auto populate fields if size of data is one
      if (purchaseOrderData.length === 1) {
        if (label === 'po_number') {
          if (poData.length === poDataAPI.length) {
            this.currentOrderDetails[label] = purchaseOrderData[0];
            this.currentOrderDetails.account_assignment_number = purchaseOrderData[0];
            this.currentOrderDetails.po_line_number = purchaseOrderData[0];
            this.purchaseOrderFieldsListData.po_number = purchaseOrderData;
            this.purchaseOrderFieldsListData.account_assignment_number = poDataAPI;
            this.purchaseOrderFieldsListData.po_line_number = poDataAPI;
          } else {
            // if original APi response is different from uniqby response
            this.purchaseOrderFieldsListData.po_number = purchaseOrderData;
            this.purchaseOrderFieldsListData.account_assignment_number = uniqBy(poDataAPI, 'account_assignment_number');
          }
        } else if (label === 'account_assignment_number') {
          // if original APi response is different from uniqby response
          if (poData.length === poDataAPI.length) {
            this.currentOrderDetails[label] = purchaseOrderData[0];
            this.currentOrderDetails.po_line_number = purchaseOrderData[0];
            this.purchaseOrderFieldsListData.account_assignment_number = poDataAPI;
            this.purchaseOrderFieldsListData.po_line_number = poDataAPI;
          } else {
            this.purchaseOrderFieldsListData.po_line_number = poDataAPI;
          }
        } else if (label === 'po_line_number') {
          this.currentOrderDetails[label] = purchaseOrderData[0];
        }
        this.currentOrderDetails.purchaseOrderId = purchaseOrderData[0].id;
        this.purchaseOrderFieldsListData = { ...this.purchaseOrderFieldsListData };
      }
      return purchaseOrderData;
    },
    /* calling purchase order API with params needed and setting the
     data for dropdown */
    async callPurchaseOrderAPI(params, label) {
      const poDataAPI = await this.$store.dispatch('indentV2/purchaseOrderFieldsListData', params);
      let poData = cloneDeep(poDataAPI);
      if (!params.po_number && !params.account_assignment_number) {
        poData = uniqBy(poData, 'po_number');
      } else if (params.po_number && !params.account_assignment_number) {
        poData = uniqBy(poData, 'account_assignment_number');
        poData = uniqBy(poData, 'po_number');
      }
      if (poData.length) {
        this.purchaseOrderFieldsListData[label] =
        this.constructPurchaseOrderDataAndAutoPopulate(poData, label, poDataAPI);
      } else {
        // if data not present show message and make po as null
        this.purchaseOrderFieldsListData.po_number = [];
        this.$errorMessage({
          message: 'No purchase order available for the current selection',
        });
      }
    },
    /*
      Search for Po number and Account Assignment Number
    */
    searchPurchaseOrder(parameter, label) {
      const params = parameter;
      if (this.currentOrderDetails) {
        if (this.currentOrderDetails.transporterId) {
          params.transporter_id = this.currentOrderDetails.transporterId;
        }
        if (this.sourcesDropOffs.length) {
          params.depot_id = this.sourcesDropOffs[0].id;
        }
        // in Edit state po_id should not be passed as params since we want to search PO no
        if (this.currentOrderDetails.purchaseOrderId && !this.isEditState) {
          params.po_number = this.currentOrderDetails.po_number.po_number;
        }
      }
      this.callPurchaseOrderAPI(params, label);
    },
    // get PO, Account Assignment, line item
    /*
      In create state  API will be called once - Po No/Acc Assi No/Po line
      In edit state APIS will be called thrice - Po No, Acc Assi No, Po line
    */
    async getPurchaseOrderFieldsListData(data) {
      try {
        const params = {
          po_number_selected: true,
          account_assignment_selected: true,
        };
        let field = 0;
        if (this.sourcesDropOffs.length) {
          params.depot_id = this.sourcesDropOffs[0].id;
        }
        if (data.transporterId) {
          field = 1;
          params.transporter_id = data.transporterId;
          if (this.isEditState) {
            await this.callPurchaseOrderAPI(params, 'po_number');
          }
        }
        if (data.po_number) {
          field = 2;
          params.po_number = data.po_number.po_number;
          if (this.isEditState) {
            await this.callPurchaseOrderAPI(params, 'account_assignment_number');
          }
        }
        if (data.account_assignment_number) {
          field = 3;
          params.account_assignment_number = data.account_assignment_number.account_assignment_number;
          if (this.isEditState) {
            await this.callPurchaseOrderAPI(params, 'po_line_number');
          }
        }
        if (!this.isEditState) { // if create state call one API
          const poDataAPI = await this.$store.dispatch('indentV2/purchaseOrderFieldsListData', params);
          let poData = cloneDeep(poDataAPI);
          if (!params.po_number && !params.account_assignment_number) {
            poData = uniqBy(poData, 'po_number');
          } else if (params.po_number && !params.account_assignment_number) {
            poData = uniqBy(poData, 'account_assignment_number');
          }
          if (poData.length) {
            if (field === 1) {
              this.purchaseOrderFieldsListData.po_number = this.constructPurchaseOrderDataAndAutoPopulate(poData, 'po_number', poDataAPI);
            } else if (field === 2) {
              this.purchaseOrderFieldsListData.account_assignment_number = this.constructPurchaseOrderDataAndAutoPopulate(poData, 'account_assignment_number', poDataAPI);
            } else if (field === 3) {
              this.purchaseOrderFieldsListData.po_line_number =
            this.constructPurchaseOrderDataAndAutoPopulate(poData, 'po_line_number', poDataAPI);
            }
            this.currentOrderDetails = { ...this.currentOrderDetails };
          } else {
            this.$errorMessage({
              message: 'No purchase order for this transporter',
            });
          }
        }
      } catch (err) {
        throw err;
      }
    },
    async getIndentUpdateReason($event, reasonSubmitted = false, freightConfirmed = false) {
      if (this.isEditState && !reasonSubmitted) {
        this.createOrUpdateEvent = $event;
        this.showIndentUpdateDialog = true;
        let depotId;
        if (this.order && [1, 2].includes(this.order.movement)) { // TODO: Use constants
          depotId = this.order.sources && this.order.sources[0]
            && this.order.sources[0].location_id;
        } else {
          depotId = this.order.destinations && this.order.destinations[0]
            && this.order.destinations[0].location_id;
        }
        const payload = {
          type: 'INDENT_EDIT',
          movement: this.order && this.order.movement,
          depot_id: depotId,
        };
        const result = await this.$store.dispatch('settings/getReasonSettings', payload);
        if (result && result.data && result.data.length) {
          const configReasons = result.data.map(item => ({
            key: item,
            value: item,
          }));
          this.indentUpdateOptions = [
            ...indentEditOptions,
            ...configReasons,
            {
              value: 'Others',
              key: 'OTHERS',
            },
          ];
        } else {
          this.indentUpdateOptions = [
            ...indentEditOptions,
            {
              value: 'Others',
              key: 'OTHERS',
            },
          ];
        }
      } else {
        this.showIndentUpdateDialog = false;
        await this.showFreightConfirmationLogic($event, freightConfirmed);
      }
    },
    async showFreightConfirmationLogic($event, freightConfirmed = false) {
      this.createOrUpdateEvent = $event;
      if (this.isEditState) {
        if (!this.showIndentUpdateDialog && isOpen(this.currentOrderDetails.type.name)
          && !freightConfirmed && this.isFreightUpdated) {
          this.showFreightConfirmationPopUp = true;
        } else {
          await this.createOrUpdateIndent(false, $event);
        }
      } else if (!this.showIndentUpdateDialog && isOpen(this.currentOrderDetails.type.name)
          && !freightConfirmed && this.isFreightUpdated) {
        this.showFreightConfirmationPopUp = true;
      } else {
        await this.createOrUpdateIndent(false, $event);
      }
    },
    async createUpdateEventHelper($event, reasonSubmitted = false, freightConfirmed = false) {
      await this.getIndentUpdateReason($event, reasonSubmitted, freightConfirmed);
    },
    /**
     * CREATE or UPDATE indent related methods
     */
    async createOrUpdateIndent(excludeCongestionCheck = false, isDraftIndent = false,
      skipIndentPrompt = false) {
      this.showFreightConfirmationPopUp = false;
      const checkCongestion = this.isEditState ?
        (this.isUnloadingCapacityEnabled && !excludeCongestionCheck && this.isVehicleRequirementDateChanged) :
        (this.isUnloadingCapacityEnabled && !excludeCongestionCheck);
      if (this.$hasFeature('indent_freight_charge') && !this.$hasPermission('create_only_rfq_indent') && this.configurations.open_creation_freight_rate_required && isOpen(this.currentOrderDetails.type.name) && !(this.currentOrderDetails.freightRate > 0) && !this.currentOrderDetails.rfq) {
        this.$errorMessage({ message: 'Enter Open Base freight' });
        return false;
      }
      try {
        // construct the payload for the indent creation or updation or congestion check
        const payload = {
          delivery_type: this.currentOrderDetails.deliveryType,
          order_type: this.currentOrderDetails.type.id,
          transporter_id: this.currentOrderDetails.transporterId || '',
          vehicle_type_id: this.currentOrderDetails.vehicleTypeId,
          sources: [],
          destinations: [],
        };
        if (this.$router.currentRoute.name !== 'indentClone') {
          payload.extend_sla_by = (this.extendSlaBy || 0);
        }

        if (this.canUpdate) {
          payload.update_reason = this.indentUpdateReason.data;
          if (this.indentUpdateReason.data === 'Others') {
            payload.update_reason = this.indentUpdateReason.custom;
          }
        }

        if (isDraftIndent || this.isSaveDraftedState) {
          this.isSaveDraftedState = true;
          if (!checkCongestion) {
            payload.is_drafted_indent = true;
          }
        }
        if (this.currentOrderDetails.shipment_number) {
          payload.shipment_number = this.currentOrderDetails.shipment_number;
        }
        if (!checkCongestion) {
          payload.no_of_vehicles = this.currentOrderDetails.no_of_vehicles || 1;
        }
        if (this.isFromCloneState) {
          payload.created_from_clone = true;
        }
        const hasVehicleCapacityCheckEnable = (this.configurations.indentConfig &&
          this.configurations.indentConfig.vehicle_capacity_check_on_change);
        if (this.isOnlyChangeTruckState) {
          payload.vehicle_changed_id = this.order.vehicle_type.id; // current vehicle id in DB
        }
        if (hasVehicleCapacityCheckEnable && this.order && this.isOnlyChangeTruckState &&
          this.order.vehicle.id !== this.currentOrderDetails.vehicle_type_id) {
          // selected vehicle
          let vehicleRequested = this.masterVehiclesList &&
              this.masterVehiclesList.find(val =>
                val.id === this.currentOrderDetails.vehicleTypeId);
          if (!vehicleRequested) {
            vehicleRequested = this.contractVehicles.find(val =>
              val.id === this.currentOrderDetails.vehicleTypeId);

            if (vehicleRequested && vehicleRequested.kg < this.order.vehicle_type.kg) {
              payload.vehicle_type_id = this.order.vehicle_type.id;
            }
          } else if (vehicleRequested.weight < this.order.vehicle_type.kg) {
            payload.vehicle_type_id = this.order.vehicle_type.id;
          }
        }
        if (this.isPoOrderTypeEnabled && this.hasPurchaseOrderConfig) {
          payload.purchase_order_id = this.currentOrderDetails &&
            this.currentOrderDetails.purchaseOrderId;
        }
        if (isOpen(this.currentOrderDetails.type.name) && this.$hasFeature('indent_freight_charge') && !checkCongestion && !this.$hasPermission('create_only_rfq_indent')) {
          payload.freight_rate = this.currentOrderDetails.freightRate ?
            parseFloat(this.currentOrderDetails.freightRate, 10) : 0;
        }
        if (isOpen(this.currentOrderDetails.type.name) && !checkCongestion) {
          payload.freight_unit = this.currentOrderDetails.open_freight_type || 1;
        }
        if (
          isOpen(this.currentOrderDetails.type.name) &&
          this.hasOpenRfqIndentConfig
        ) {
          payload.rfq = this.currentOrderDetails.rfq || false;
          if (payload.rfq) {
            payload.transporter_ids = payload.transporter_id;
            payload.transporter_id = '';
            if (this.$hasPermission('view_rfq_ceiling_price')) {
              if (this.currentOrderDetails.ceiling_price < 0) {
                this.$errorMessage({ message: 'Ceiling price must be larger than or equal to 0' });
                return false;
              }
              payload.ceiling_price = (this.currentOrderDetails.ceiling_price) ?
                parseInt(this.currentOrderDetails.ceiling_price, 10) :
                0;
            }
            if (this.$hasPermission('view_rfq_historical_price')) {
              if (this.currentOrderDetails.historical_price < 0) {
                this.$errorMessage({ message: 'Historical price must be greater than or equal to 0' });
                return false;
              }
              payload.historical_price = (this.currentOrderDetails.historical_price)
                ? parseInt(this.currentOrderDetails.historical_price, 10) : 0;
            }
            payload.no_of_materials = (this.currentOrderDetails.no_of_materials)
              ? this.currentOrderDetails.no_of_materials : 0;
            payload.material_weight = (this.currentOrderDetails.material_weight)
              ? this.currentOrderDetails.material_weight : 0;
            payload.material_volume = (this.currentOrderDetails.material_volume)
              ? this.currentOrderDetails.material_volume : 0;
          }
          if (checkCongestion) {
            delete payload.transporter_ids;
            delete payload.rfq;
            delete payload.ceiling_price;
            delete payload.historical_price;
            delete payload.no_of_materials;
            delete payload.material_weight;
            delete payload.material_volume;
          }
        } else if (this.isMarketIndent && !checkCongestion) {
          payload.transit_days = this.transitDays;
          payload.transporter_id = '';
        } else if (this.isNoFreightIndent && !checkCongestion) {
          payload.freight_type = this.currentOrderDetails.freightType;
        }
        this.sourcesDropOffs.forEach((sourceDropOffDetail) => {
          const source = {
            type: parseInt(sourceDropOffDetail.type, 10),
            location_id: sourceDropOffDetail.id, // source id
          };
          sourceDropOffDetail.pickups.forEach((pickup) => {
            const pickupDetails = {
              gate_id: pickup.id, // source gate id
              dock_id: pickup.dockId,
              vehicle_requirement_date: moment(
                pickup.vehicle_requirement_date || new Date(),
              ).toISOString(),
            };
            if (!checkCongestion) {
              pickupDetails.loader_available = pickup.loader_available || false;
              pickupDetails.add_to_invoice = pickup.add_to_invoice || false;
            }
            // To map sequence number for pickups
            if (this.pickupDropSequence) {
              let sourceData = null;
              if (source.type === sourceAndDestinationType.CONSIGNEE) {
                sourceData = this.pickupDropSequence.sources.find(entry => entry.ref_id === sourceDropOffDetail.reference_id);
              } else {
                sourceData = this.pickupDropSequence.sources.find(entry => entry.ref_id === pickup.reference_id);
              }
              if (sourceData) {
                pickupDetails.sequence_number = sourceData.sequence;
              }
            }
            payload.sources.push({ ...source, ...pickupDetails });
            pickup.dropoffs.forEach((drop) => {
              const destination = {
                type: parseInt(drop.ship_to.type, 10), // ship to type
                location_id: drop.ship_to.location_id || drop.ship_to.id, // destination ship to id(if parent present -> set location_id)
                source_location_id: source.location_id, // source id
                source_gate_id: pickup.id, // source gate id
                sold_to_id: drop.sold_to.id, // destination sold to id(PRIORITY: 1. gate id 2.location id)
              };
              if (!checkCongestion) {
                destination.unloader_available = drop.unloader_available || false;
                destination.add_to_invoice = drop.add_to_invoice || false;
              }
              if (destination.type === this.sourceAndDestinationType.DEPOT) {
                destination.gate_id = drop.ship_to.id;
              }

              if (!this.isContract) {
                // set the expected date to VRD if expected date is not given.
                if (isOpen(this.currentOrderDetails.type.name)) {
                  destination.expected_delivery_at = drop.expected_date ? moment(drop.expected_date).toISOString() : '';
                } else {
                  destination.expected_delivery_at = moment(
                    drop.expected_date || pickupDetails.vehicle_requirement_date,
                  ).toISOString();
                }
              }
              // To map sequence number for drops
              if (this.pickupDropSequence) {
                const destinationEntry = this.pickupDropSequence.destinations.find((entry) => {
                  const sameRefId = (entry.ref_id === drop.ship_to.reference_id);
                  if (entry.source_gate_id) {
                    return sameRefId && (entry.source_gate_id === pickupDetails.gate_id);
                  }
                  return sameRefId && entry.source_location_id === source.location_id;
                });
                if (destinationEntry) {
                  destination.sequence_number = destinationEntry.sequence;
                }
              }
              payload.destinations.push(destination);
            });
          });
        });
        if (checkCongestion) {
          await this.checkCongestion(payload);
          return;
        }

        if (this.configurations && this.configurations.max_drop_allowed_count_for_ptl && this.configurations.max_drop_allowed_count_for_ptl !== 0 &&
         payload.destinations.length > this.configurations.max_drop_allowed_count_for_ptl && payload.delivery_type === deliveryTypes.PTL) {
          this.showIndentPromptDropLimit = true;
          return;
        }
        if (payload.destinations.length > 1 && payload.delivery_type === deliveryTypes.PTL &&
          this.$hasFeature('restrict_multi_drop_for_ptl') && !this.showIndentPrompt) {
          this.showIndentPrompt = true;
          return;
        }
        if (!isOpen(this.currentOrderDetails.type.name) && this.$hasFeature('consider_return_freight_charge')) {
          payload.consider_return_freight_charge = this.currentOrderDetails.consider_return_freight_charge;
        }
        if (this.isProcess) { return; }
        this.isProcess = true;
        if (this.isCreateFromDraftState) {
          if (this.isSaveDraftedState) { // edit draft
            await this.editOrder(payload);
          } else { // create indent from draft
            await this.createFromDraft(payload);
          }
        } else if (this.isEditState) {
          const isOptimaIndent = !!this.getOptimaInfo;
          await this.editOrder(payload, isOptimaIndent);
          if (this.currentOrderDetails.rfq && this.getOptimaInfo) { // For optima indent (open to rfq conversion)
            const params = {
              orderNo: this.currentOrderDetails.order_number,
              transporterIds: payload.transporter_ids,
              loadDate: new Date(payload.sources[0].vehicle_requirement_date.toString()),
              freight_unit: payload.freight_unit || 1,
              is_all_selected: false,
              remarks: '',
              no_of_materials: this.order.materialCount || 0,
              material_weight: this.getOptimaInfo.total_weight || 0,
              material_volume: this.getOptimaInfo.total_volume || 0,
            };
            if (payload.vehicle_type_id) {
              params.changed_vehicle_id = payload.vehicle_type_id;
            }
            const result = await this.$store.dispatch('order/rfq', params);
            if (result && result.error) {
              this.$error({ message: result.error });
            } else {
              this.$success({ message: this.$t('INDENT_REQUEST_FOR_QUOTES') });
            }
          }
        } else {
          await this.createOrder(payload, this.isSaveDraftedState);
        }
        this.isProcess = false;
      } catch (err) {
        this.$errorMessage({ message: this.$t('APP_CATCH_ERR') });
      }
    },
    async checkCongestion(payload) {
      const result = await this.$store.dispatch(
        'indentV2/checkVehicleCongestion',
        payload,
      );
      if (result && result.length) {
        this.showVehicleCongestion = true;
        this.vehicleCongestionIn = result;
      } else {
        this.createOrUpdateIndent(true); // create indent excluding the vehicle congestion check
      }
    },

    async createOrder(payload, isDraft = false) {
      const type = isDraft ? 'DRAFT' : 'INDENT';
      try {
        const result = await this.$store.dispatch(
          'indentV2/createIndent',
          {
            data: payload,
            allTransportersSelected: this.allTransportersSelected,
          },
        );
        if (result && result.error) {
          if (result.error === 'ERR_DUPLICATE_SHIPMENT_NUMBER - Validation  error') {
            this.$errorMessage({
              message: indentCreateUpdateErrors.ERR_DUPLICATE_SHIPMENT_NUMBER,
            });
          } else if (result.error === 'ERR_ACCEPTANCE_SLA_NOT_FOUND') {
            this.$errorMessage({
              message: indentCreateUpdateErrors.ERR_ACCEPTANCE_SLA_NOT_FOUND,
            });
          } else if (((result.error).slice(0, 30)) === 'shipment_number length must be') {
            this.$errorMessage({
              message: result.error,
            });
          } else if (result.error === 'ERR_ROUTE_DOES_NOT_EXIST - Validation  error') {
            this.$errorMessage({
              message: indentCreateUpdateErrors.ERR_ROUTE_DOES_NOT_EXIST,
            });
          } else if (result.error === 'ERR_CHECK_ROUTE_MASTER_FEATURE_MISSING - Validation  error') {
            this.$errorMessage({
              message: indentCreateUpdateErrors.ERR_CHECK_ROUTE_MASTER_FEATURE_MISSING,
            });
          } else {
            this.$errorMessage({
              message: result.error,
            });
          }
        } else {
          this.$successMessage({
            message: this.$getSuccess(`${type}_CREATION`, {
              firstArgument: (result && Array.isArray(result) && result.join(',')) || '',
            }),
          });
          this.routeToIndent();
        }
      } catch (err) {
        this.$errorMessage({ message: this.$getErr(`${type}_CREATION_FAILS)`) });
      }
    },

    async editOrder(payload, isOptimaIndent = false) {
      try {
        const result = await this.$store.dispatch(
          'indentV2/updateIndent',
          {
            id: this.currentOrderDetails.order_number,
            data: payload,
            isOptimaIndent,
          },
        );
        if (result && result.error) {
          if (result.error === 'ERR_DUPLICATE_SHIPMENT_NUMBER - Validation  error') {
            this.$errorMessage({
              message: indentCreateUpdateErrors.ERR_DUPLICATE_SHIPMENT_NUMBER,
            });
          } else if (result.error === 'ERR_EXTEND_SLA_BY - Validation  error') {
            this.$errorMessage({
              message: indentCreateUpdateErrors.ERR_EXTEND_SLA_BY,
            });
          } else if (result.error === 'ERR_ROUTE_DOES_NOT_EXIST - Validation  error') {
            this.$errorMessage({
              message: indentCreateUpdateErrors.ERR_ROUTE_DOES_NOT_EXIST,
            });
          } else if (result.error === 'ERR_CHECK_ROUTE_MASTER_FEATURE_MISSING - Validation  error') {
            this.$errorMessage({
              message: indentCreateUpdateErrors.ERR_CHECK_ROUTE_MASTER_FEATURE_MISSING,
            });
          } else {
            this.$errorMessage({
              message: this.$getErr('INDENT_UPDATION_FAILS'),
            });
          }
        } else {
          this.$successMessage({
            message: this.$getSuccess('INDENT_UPDATION', {
              firstArgument: (result && result.order_no) || '',
            }),
          });
          this.routeToIndent();
        }
      } catch (err) {
        this.$errorMessage({ message: this.$getErr('INDENT_UPDATION_FAILS') });
      }
    },

    async createFromDraft(payload) { // create a indent from drafted indent
      try {
        const result = await this.$store.dispatch(
          'indentV2/createIndentFromDraft',
          {
            id: this.currentOrderDetails.order_number,
            data: payload,
            allTransportersSelected: this.allTransportersSelected,
          },
        );
        if (result && result.error) {
          if (result.error === 'ERR_DUPLICATE_SHIPMENT_NUMBER - Validation  error') {
            this.$errorMessage({
              message: indentCreateUpdateErrors.ERR_DUPLICATE_SHIPMENT_NUMBER,
            });
          } else {
            this.$errorMessage({
              message: this.$getErr('INDENT_CREATION_FAILS'),
            });
          }
        } else {
          this.$successMessage({
            message: this.$getSuccess('INDENT_CREATION', {
              firstArgument: (result && result.join(',')) || '',
            }),
          });
          if (this.getCurrentIndentType.name === 'OUTBOUND') {
            this.$router.push({ name: 'OutboundIndents' });
          } else {
            this.$router.push({ name: 'InboundIndents' });
          }
        }
      } catch (err) {
        this.$errorMessage({ message: this.$getErr('INDENT_CREATION_FAILS') });
      }
    },

    routeToIndent() {
      const type = this.$route.params.type || 0;
      if (this.isEximIndent) {
        this.$router.go(-1);
      } else if (parseInt(type, 10) === 1) {
        this.$router.push({ name: 'InboundIndents' });
      } else {
        this.$router.push({ name: 'OutboundIndents' });
      }
    },

    /**
     * CONTRACT based methods
     */
    changeContractVehicles(data) {
      this.contractVehicles = data;
    },
    freightUpdated($event) {
      this.isFreightUpdated = $event;
    },

    /**
     * INDENT details(ordertype, delivery type,vehicles, transporters, etc.) based methods
     */
    async changeIndentDetails(data) {
      if (data.transporterId && this.previousTransporterId !== data.transporterId) {
        this.setNewVehicleRequirementDate();
        this.sourcesDropOffs = [...this.sourcesDropOffs];
      }
      this.currentOrderDetails = { ...this.currentOrderDetails, ...data };

      if (this.hasPurchaseOrderConfig && this.isPoOrderTypeEnabled && data.transporterId) {
        await this.getPurchaseOrderFieldsListData(data);
      } else {
        this.purchaseOrderFieldsListData.po_number = [];
        this.purchaseOrderFieldsListData.account_assignment_number = [];
        this.purchaseOrderFieldsListData.po_line_number = [];
      }
    },

    clearIndentDetails(forceClear = false) {
      if ((this.isContract || forceClear) && this.canEditDetails) {
        this.currentOrderDetails = {
          ...this.currentOrderDetails,
          vehicleTypeId: null,
          transporterId: null,
          deliveryType: null,
        };
        this.selectedTransporterName = '';
        this.$refs.indentDetails.checkedTransporters = [];
      }
    },
    clearTransporterDetails() {
      this.currentOrderDetails = {
        ...this.currentOrderDetails,
        transporterId: null,
      };
      this.selectedTransporterName = '';
      this.$refs.indentDetails.checkedTransporters = [];
    },
    async setOrderType(orderTypeName) {
      if (isContract(orderTypeName)) {
        const contractCheck =
          (this.noSourcesSelected || !this.isAtleastOneDropSelected) ||
            (!this.canEditDetails && !this.isOnlyChangeTruckState)
            ? true
            : await this.checkContract();
        let userResponse = false;
        if (contractCheck) {
          this.currentOrderDetails.type = orderTypes.find(
            val => val.name === orderTypeName,
          );
          this.currentOrderDetails.rfq = false;
          this.clearIndentDetails();
        } else if (this.currentOrderDetails.type && !isContract(this.currentOrderDetails.type.name)) {
          this.$errorMessage({
            message: 'No contracts founds for the consigments',
          });
        } else {
          userResponse = await this.openSwitchOpenIndentDialog(true);
          if (userResponse) {
            this.resetFreight();
          }
          if (!userResponse && !this.isOnlyChangeTruckState) {
            this.sourcesDropOffs.forEach((source, sourceIndex) => {
              source.pickups.forEach((pickup, pickupIndex) => {
                this.sourcesDropOffs[sourceIndex].pickups[pickupIndex].dropoffs = [];
              });
            });
            this.sourcesDropOffs = [...this.sourcesDropOffs];
            return false; // sending false to stop setting vehicles and transporter details
          }
        }
      } else {
        // OPEN or NO FREIGHT or MARKET
        if (!this.isEditState) {
          this.resetFreight();
        }
        this.currentOrderDetails.type = orderTypes.find(
          val => val.name === orderTypeName,
        );
        const vehicleListParams = isMarket(orderTypeName) ? 'market' : 'all';
        await this.$store.dispatch('indentV2/getAllVehicles', {
          list: vehicleListParams,
        });
        if (!isMarket(orderTypeName)) {
          this.currentOrderDetails.open_freight_type = this.currentOrderDetails.freight_unit || 1;
          this.clearTransporterDetails();
        }
        if (!isOpen(orderTypeName)) {
          this.clearIndentDetails(true); // force clear only during switch
        }
        if (this.isNoFreightIndent) {
          await this.$store.dispatch('indentV2/getAllTransporters');
          this.currentOrderDetails.open_freight_type = this.currentOrderDetails.freight_unit || 1;
        }
        this.currentOrderDetails.rfq = this.$hasPermission('create_only_rfq_indent');
      }
      this.currentOrderDetails = { ...this.currentOrderDetails };
      return true;
    },
    setNewVehicleRequirementDate() {
      if ((this.currentOrderDetails.type.id === orderType.CONTRACT ||
        this.currentOrderDetails.type.id === orderType.OPEN) &&
        (this.indentCutOff && this.indentArrivalCutOff)) {
        const actualVehicleRequirementDate =
          new Date(this.sourcesDropOffs[0].pickups[0].vehicle_requirement_date);

        const vehicleReqDate = getVehicleRequirementDate(actualVehicleRequirementDate,
          this.indentCutOff, this.indentArrivalCutOff);

        const isSameDate = (actualVehicleRequirementDate === vehicleReqDate);
        this.updateVehicleRequirementDate(vehicleReqDate);
        if (!isSameDate) {
          this.$success({
            message: 'Vehicle requirement date has been update to next date',
          });
        }
      }
    },
    updateVehicleRequirementDate(vehicleRequirementDate) {
      this.sourcesDropOffs.forEach((_sourcesDropOff, index) => {
        _sourcesDropOff.pickups.forEach((_pickup, pickupIndex) => {
          this.sourcesDropOffs[index].pickups[pickupIndex].vehicle_requirement_date =
            vehicleRequirementDate;
        });
      });
    },
    setGA(action, description) {
      this.$addGAEvent('Indent Management', action, `${this.getGAEventCategory}:${description}`);
    },
    updateTransporterName(val) {
      this.selectedTransporterName = val;
    },
    // Storing sequential data for appending sequence number during save/update
    updateSequenceData(data) {
      this.pickupDropSequence = data;
    },
  },
};
</script>
<style>
.indent-update-dialog {
    position: fixed;
    right: 0;
}
</style>
